var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { extractData, getFetchOptions } from "../utils";
import { showModalFromHtml } from "../components/modal";
import EventBus from "../events/EventBus";
var instance;
var channel;
var productsList = new Set();
var brandsList = new Set();
// раньше гостевое избранное лежало в Local Storage, теперь его хранит сервер
var LEGACY_LOCAL_STORAGE_NAME = 'favorites';
function initFavorites() {
    if (window.BroadcastChannel) {
        channel = new BroadcastChannel('favorites');
        channel.addEventListener('message', function (_a) {
            var data = _a.data;
            loadData(data, false);
        });
    }
    loadData(extractData(document.getElementById('favorites-data')));
    importLegacyFavorites();
    return { toggleFavorite: toggleFavorite, has: has };
}
export function useFavoritesApi() {
    return instance !== null && instance !== void 0 ? instance : (instance = initFavorites());
}
function toggleFavorite(id, brand) {
    return __awaiter(this, void 0, Promise, function () {
        var list, status;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    list = brand ? brandsList : productsList;
                    return [4 /*yield*/, fetch('/api/favorites/toggle', getFetchOptions({ id: id, brand: brand }, true))
                            .then(function (response) { return response.json(); })
                            .then(function (response) {
                            if (!response.ok) {
                                return list.has(id);
                            }
                            if (response.html) {
                                showModalFromHtml(response.html);
                            }
                            return response.status;
                        })];
                case 1:
                    status = _a.sent();
                    if (status) {
                        list.add(id);
                    }
                    else {
                        list.delete(id);
                    }
                    notifyChange();
                    return [2 /*return*/, status];
            }
        });
    });
}
function has(id, brand) {
    return brand ? brandsList.has(id) : productsList.has(id);
}
function loadData(data, notify) {
    var _a, _b;
    if (notify === void 0) { notify = true; }
    var newProductsList = (_a = data === null || data === void 0 ? void 0 : data.products) !== null && _a !== void 0 ? _a : [];
    var newBrandsList = (_b = data === null || data === void 0 ? void 0 : data.brands) !== null && _b !== void 0 ? _b : [];
    if (newProductsList === Array.from(productsList) && newBrandsList === Array.from(brandsList)) {
        return;
    }
    productsList = new Set(newProductsList);
    brandsList = new Set(newBrandsList);
    EventBus.emit('favorites:change');
    if (notify) {
        notifyChange();
    }
}
function notifyChange() {
    channel === null || channel === void 0 ? void 0 : channel.postMessage({
        products: Array.from(productsList),
        brands: Array.from(brandsList),
    });
}
function importLegacyFavorites() {
    var _a, _b;
    var legacy = localStorage.getItem(LEGACY_LOCAL_STORAGE_NAME);
    if (legacy === null) {
        return;
    }
    var data = JSON.parse(legacy);
    fetch('/api/favorites/import', getFetchOptions({ products: (_a = data === null || data === void 0 ? void 0 : data.products) !== null && _a !== void 0 ? _a : [], brands: (_b = data === null || data === void 0 ? void 0 : data.brands) !== null && _b !== void 0 ? _b : [] }, true))
        .then(function (response) { return response.json(); })
        .then(function (response) {
        if (response.ok) {
            localStorage.removeItem(LEGACY_LOCAL_STORAGE_NAME);
            loadData({ products: response.products, brands: response.brands });
        }
    });
}
